class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
    this.classList.add("animate", "active");
    // Skip updateCartUpsellToggleState here — already called by cart.js onCartUpdate
    document.dispatchEvent(new CustomEvent('cart:open'));
  });

    this.addEventListener("transitionend", () => {
  const containerToTrapFocusOn = this.classList.contains("is-empty")
    ? this.querySelector(".drawer__inner-empty")
    : document.getElementById("CartDrawer");
  
  // Guard against null
  if (!containerToTrapFocusOn) return;
  
  const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
  trapFocus(containerToTrapFocusOn, focusElement);
}, { once: true });


    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
async renderContents(parsedState) {
  try {
    const sectionsToRender = this.getSectionsToRender();
    let sections = parsedState.sections;

    // The item was already added. Fetch HTML only, never add it again.
    if (
      !sections ||
      sectionsToRender.some(
        (section) => typeof sections[section.id] !== "string"
      )
    ) {
      const url = new URL(
        window.Shopify?.routes?.root || "/",
        window.location.origin
      );

      url.searchParams.set(
        "sections",
        sectionsToRender.map((section) => section.id).join(",")
      );

      const response = await fetch(url.toString(), {
        credentials: "same-origin",
        cache: "no-store",
      });

      if (!response.ok) {
        throw new Error("Could not refresh cart sections");
      }

      sections = await response.json();
    }

    // Validate the returned HTML before changing the drawer.
    const updates = sectionsToRender.map((section) => {
      const target = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      const html = sections?.[section.id];

      if (typeof html !== "string") {
        throw new Error(`Missing cart section: ${section.id}`);
      }

      const source = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(section.selector || ".shopify-section");

      if (!source) {
        throw new Error(`Invalid cart section: ${section.id}`);
      }

      return { target, html: source.innerHTML };
    });

    updates.forEach(({ target, html }) => {
      if (target) target.innerHTML = html;
    });

    this.productId = parsedState.id;
    this.classList.remove("is-empty");
    this.querySelector(".drawer__inner")?.classList.remove("is-empty");

    // Reattach the overlay listener after replacing the drawer HTML.
    this.querySelector("#CartDrawer-Overlay")?.addEventListener(
      "click",
      this.close.bind(this)
    );

    requestAnimationFrame(() => this.open());
  } catch (error) {
    console.error("Cart drawer refresh failed:", error);

    // Show the current cart instead of leaving a stale drawer.
    window.location.assign(
      window.routes?.cart_url ||
        `${window.Shopify?.routes?.root || "/"}cart`
    );
  }
}


  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
